import { Injectable, inject } from '@angular/core';
import * as moment from 'moment-timezone';
import { json } from 'express';
import * as firebase from 'firebase/app';
// import { Timestamp } from 'firebase/firestore';
// import { firestore } from 'firebase/app';
// import firebase from 'firebase/app';
// import 'firebase/compat/auth';
// import 'firebase/compat/firestore';
import { getFirestore, enableMultiTabIndexedDbPersistence } from '@angular/fire/firestore';
// import { AngularFireStorage } from '@angular/fire/compat/storage';
import { PLATFORM_ID, Inject } from '@angular/core';
import { HttpClientModule, HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
// import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BehaviorSubject, combineLatest, switchMap } from 'rxjs';
import xml2js from 'xml2js';

import { Firestore, collectionData, collection } from '@angular/fire/firestore';

// import {Timestamp} from 'firebase/firestore';
// import { Timestamp } from '@firebase/firestore-types';

import { Observable } from 'rxjs';
import { Timestamp } from 'firebase/firestore';


export class Day {
    id!: string;  // day+month+year
    // date: 
    list: Show[] | undefined
    date: moment.Moment | undefined

    constructor(jsonObj?: any) {
        this.clone(jsonObj)
    }

    clone(jsonObj?: any) {
        if (jsonObj == undefined) {
            jsonObj = {}
        }
        this.id = jsonObj.id ? jsonObj.id : ''
        this.date = jsonObj.date ? jsonObj.date : undefined
        this.list = new Array<Show>();
        if (jsonObj.list) {
            this.list = jsonObj.list.map((item: any) => new Show(item));
        }
    }

    addToList(show: Show) {
        let found: boolean = false

        this.list.forEach(item => {
            if (item.title == show.title) {
                if (item.start.isEqual(show.start)) {
                    found = true
                    console.log('caught duplicate')
                }
            }
        })

        if (!found) {
            this.list?.push(show)
        }
    }


}


export class Show {
    start: Timestamp | undefined;
    end: Timestamp | undefined
    duration!: number
    programType!: string
    programId!: string
    videoId!: string
    videoIdPartner!: string
    thumbnail!: string
    title!: string
    titleInternal!: string
    description!: string
    keywords!: string
    ratingAge!: number
    parentalRating!: string
    country!: string
    countryName!: string
    language!: string
    languageName!: string
    contentType!: string
    contentFormat!: string
    genre!: string
    seriesId!: string
    series!: string
    season!: number
    episode!: number
    adBreakPositions!: string
    externalMetadataId!: string
    poster!: string
    videoPublishDate!: Timestamp | undefined
    disabled: boolean
    soon: string = ''

    position: number = 0
    manual: boolean = false
    isCurrentlyPlaying: boolean = false

    constructor(jsonObj?: any) {
        this.clone(jsonObj)
    }

    clone(jsonObj?: any) {
        if (jsonObj == undefined) {
            jsonObj = {}
        }

        if (typeof jsonObj.start == 'object') {
            this.start = jsonObj.start ? jsonObj.start : undefined
        }
        else {
            this.start = jsonObj.start ? Timestamp.fromDate(new Date(jsonObj.start)) : undefined
        }
        if (typeof jsonObj.end == 'object') {
            this.end = jsonObj.end ? jsonObj.end : undefined
        }
        else {
            this.end = jsonObj.end ? Timestamp.fromDate(new Date(jsonObj.end)) : undefined
        }
        this.duration = jsonObj.duration ? jsonObj.duration : 0
        this.position = jsonObj.position ? jsonObj.position : 0
        this.programType = jsonObj.programType ? jsonObj.programType : ''
        this.programId = jsonObj.programId ? jsonObj.programId : ''
        this.videoId = jsonObj.videoId ? jsonObj.videoId : ''
        this.videoIdPartner = jsonObj.videoIdPartner ? jsonObj.videoIdPartner : ''
        this.thumbnail = jsonObj.thumbnail ? jsonObj.thumbnail : ''
        this.title = jsonObj.title ? jsonObj.title : ''
        this.titleInternal = jsonObj.titleInternal ? jsonObj.titleInternal : ''
        this.description = jsonObj.description ? jsonObj.description : ''
        this.keywords = jsonObj.keywords ? jsonObj.keywords : ''
        this.ratingAge = jsonObj.ratingAge ? jsonObj.ratingAge : 0
        this.parentalRating = jsonObj.parentalRating ? jsonObj.parentalRating : ''
        this.countryName = jsonObj.countryName ? jsonObj.countryName : ''
        this.language = jsonObj.language ? jsonObj.language : ''
        this.languageName = jsonObj.languageName ? jsonObj.languageName : ''
        this.contentType = jsonObj.contentType ? jsonObj.contentType : ''
        this.contentFormat = jsonObj.contentFormat ? jsonObj.contentFormat : ''
        this.genre = jsonObj.genre ? jsonObj.genre : ''
        this.seriesId = jsonObj.seriesId ? jsonObj.seriesId : ''
        this.series = jsonObj.series ? jsonObj.series : ''
        this.season = jsonObj.season ? jsonObj.season : 0
        this.episode = jsonObj.episode ? jsonObj.episode : 0
        this.adBreakPositions = jsonObj.adBreakPositions ? jsonObj.adBreakPositions : ''
        this.externalMetadataId = jsonObj.externalMetadataId ? jsonObj.externalMetadataId : ''
        this.poster = jsonObj.poster ? jsonObj.poster : ''
        this.videoPublishDate = jsonObj.videoPublishDate ?
            Timestamp.fromDate(new Date(jsonObj.videoPublishDate)) : undefined
        this.disabled = false
        this.soon = jsonObj.soon ? jsonObj.soon : ''
        this.manual = jsonObj.manual ? jsonObj.manual == true : false

        this.init()
    }

    init() {
        this.setupCurrentState()
        this.setupLiveTimer()
        this.setupEndTimer()
    }

    setupCurrentState() {
        var now = moment();
        var date = moment(this.start?.toDate())
        var end = moment(this.end?.toDate())

        if (date.diff(now) < 0 && end.diff(now) > 0) {
            this.isCurrentlyPlaying = true
        }
    }

    setupLiveTimer() {
        var now = moment();
        var date = moment(this.start?.toDate())
        var end = moment(this.end?.toDate())

        if (date.diff(now) > 0) {
            setTimeout(() => {
                this.isCurrentlyPlaying = true
            }, date.diff(now));
        }
    }

    setupEndTimer() {
        var now = moment();
        var date = moment(this.start?.toDate())
        var end = moment(this.end?.toDate())

        if (end.diff(now) > 0) {
            setTimeout(() => {
                this.isCurrentlyPlaying = false
            }, end.diff(now));
        }
    }

    getSave(): any {
        return {
            start: this.start,
            end: this.end,
            duration: this.duration,
            position: this.position,
            programType: this.programType,
            programId: this.programId,
            videoId: this.videoId,
            videoIdPartner: this.videoIdPartner,
            thumbnail: this.thumbnail,
            poster: this.poster,
            title: this.title,
            titleInternal: this.titleInternal,
            description: this.description,
            keywords: this.keywords,
            ratingAge: this.ratingAge,
            parentalRating: this.parentalRating,
            countryName: this.countryName,
            language: this.language,
            languageName: this.languageName,
            contentType: this.contentType,
            contentFormat: this.contentFormat,
            genre: this.genre,
            seriesId: this.seriesId,
            series: this.series,
            season: this.season,
            episode: this.episode,
            adBreakPositions: this.adBreakPositions,
            externalMetadataId: this.externalMetadataId,
            videoPublishDate: this.videoPublishDate,
            manual: this.manual
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    // apiURL10: string = 'https://static.frequency.com/studio/epg/585.json'
    apiURL1: string = "assets/json/585.json"
    apiURL2: string = "assets/json/json_EPG_sample[139184].json"

    showList: Show[] = []
    daysList: Day[] = []

    showListMovieSphere: Show[] = []
    daysListMovieSphere: Day[] = []


    dayIDSelected: string = ''
    daySelected!: Day;
    posterList: Show[] = []
    // moviespherePosterList: Show[] = []
    public posterList$: BehaviorSubject<Show[]>;
    // public posterList$: BehaviorSubject<Show[]>;
    // public posterList$: Observable<Show[]>;
    private startFilter$: BehaviorSubject<string | null>;


    isLoading: boolean = true

    public xmlItems: any;

    constructor(
        private http: HttpClient,
        private firestore: Firestore,
        @Inject(PLATFORM_ID) private platformId: Object,

    ) {
        // this.getApiData1()

        this.posterList$ = <BehaviorSubject<Show[]>>new BehaviorSubject(new Array<Show>());

        this.startFilter$ = new BehaviorSubject<string | null>(null);

        // this.getPosterList()
        // this.loadXML()
    }

    getPosterList(id) {
        // combineLatest(
        //     this.startFilter$
        // ).pipe(
        //     switchMap(([path]) =>
        //         collection<Show>(this.firestore, 'posters', ref => ref.where('hidden', '!=', false)).valueChanges({ idField: "id" })
        //     )
        // ).subscribe(data => {
        //     this.isLoading = false
        //     this.posterList = data.map(item => {
        //         let show = new Show(item)
        //         return show
        //     });
        //     console.log('Data received')
        //     console.info(this.posterList)
        //     this.posterList$.next(this.posterList);
        // })



        const aCollection = collection(this.firestore, id)

        // this.posterList$ = collectionData(aCollection);

        combineLatest(
            this.startFilter$
        ).pipe(
            switchMap(([path]) =>
                collectionData(aCollection)
            )
        ).subscribe(data => {
            this.isLoading = false
            this.posterList = data.map(item => {
                let show = new Show(item)
                if (item.date != undefined) {
                    show.start = item.date
                }
                else {
                    show.start = item.start
                }
                show.end = item.end ? item.end : item.date
                return show
            });
            this.posterList.sort((a, b) => a.position - b.position)
            this.posterList = this.posterList.splice(0, 4)
            console.log('Data received')
            console.info(this.posterList)
            this.posterList$.next(this.posterList);

            // setTimeout(() => {

            //     for(let i=0; i< this.posterList.length; i++) {

            //         let lngth = this.getAllTitles(this.posterList[i].title).length
            //         if(lngth == 0) {
            //             this.posterList[i].disabled = true
            //         }
            //     }
            //     this.posterList$.next(this.posterList);
            // }, 500);
            this.refreshEnabled()

        })
    }

    refreshEnabled() {
        for (let i = 0; i < this.posterList.length; i++) {
            // TODO: remove this line to enable the dates
            this.posterList[i].soon = ''

            let lngth = this.getAllTitles(this.posterList[i].title).length
            if (lngth == 0) {
                this.posterList[i].disabled = true
                // has manual date and manual enabled
                if (this.posterList[i].manual) {
                    this.posterList[i].disabled = false
                }
            }
            else {
                this.posterList[i].disabled = false
                this.posterList[i].soon = ''
            }
        }
        this.posterList$.next(this.posterList);
    }

    getApiData1(defaultThumb) {
        this.showList = []
        this.daysList = []

        this.showListMovieSphere = []
        this.daysListMovieSphere = []

        this.daySelected = null
        this.dayIDSelected = ''


        this.http.get<any>(this.apiURL1).subscribe((data: any) => {
            console.log(data)

            this.showList = data.schedule.map((item: any) => {
                let show = new Show(item)
                return show
            });

            this.showList.forEach(item => {
                let date: moment.Moment
                let dayID: string

                date = moment(item.start?.toDate())
                dayID = date.tz('America/Los_Angeles').format("YYYY-MM-DD");

                if (date.diff(moment()) > 0) {
                    var found: boolean = false
                    let index = this.daysList.findIndex((day) => day.id == dayID)
                    if (index == -1) {
                        let day = new Day({
                            id: dayID,
                            date: date
                        });
                        this.daysList.push(day)
                        index = this.daysList.length - 1
                    }
                    if (item.thumbnail == '') {
                        item.thumbnail = defaultThumb
                    }

                    this.daysList[index].addToList(item);

                    if (this.dayIDSelected == '') {
                        this.selectDay(dayID)
                    }
                }

                // console.log(date.format('D'));
            });
            console.log(this.daysList)

            console.log('done')
            this.refreshEnabled()
        })
    }

    loadXML(xml, defaultThumb, startDate) {
        this.showList = []
        this.daysList = []

        this.showListMovieSphere = []
        this.daysListMovieSphere = []

        this.daySelected = null
        this.dayIDSelected = ''

        /*Read Data*/
        this.http.get(xml,
            {
                headers: new HttpHeaders()
                    .set('Content-Type', 'text/xml')
                    .append('Access-Control-Allow-Methods', 'GET')
                    .append('Access-Control-Allow-Origin', '*')
                    .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"),
                responseType: 'text'
            })
            .subscribe((data) => {
                this.parseXML(data, defaultThumb)
                    .then((data: Show[]) => {
                        this.showListMovieSphere = data;

                        this.showListMovieSphere.forEach(item => {
                            let date: moment.Moment
                            let endDate: moment.Moment
                            let dayID: string

                            date = moment(item.start?.toDate())
                            endDate = moment(item.end?.toDate())
                            dayID = date.tz('America/Los_Angeles').format("YYYY-MM-DD");

                            var forcedStart = moment(startDate);

                            if (forcedStart.diff(moment()) < 0) {
                                forcedStart = moment()
                            }

                            if (date.diff(forcedStart) > 0) {

                                var found: boolean = false
                                let index = this.daysList.findIndex((day) => day.id == dayID)
                                if (index == -1) {
                                    let day = new Day({
                                        id: dayID,
                                        date: date
                                    });
                                    this.daysList.push(day)
                                    index = this.daysList.length - 1
                                }
                                // this.daysListMovieSphere[index].addToList(item);
                                this.daysList[index].addToList(item);

                                if (this.dayIDSelected == '') {
                                    this.selectDay(dayID)
                                }
                            }
                            else {
                                if (endDate.diff(forcedStart) > 0) {

                                    var found: boolean = false
                                    let index = this.daysList.findIndex((day) => day.id == dayID)
                                    if (index == -1) {
                                        let day = new Day({
                                            id: dayID,
                                            date: date
                                        });
                                        this.daysList.push(day)
                                        index = this.daysList.length - 1
                                    }
                                    // this.daysListMovieSphere[index].addToList(item);
                                    this.daysList[index].addToList(item);

                                    if (this.dayIDSelected == '') {
                                        this.selectDay(dayID)
                                    }
                                }
                            }
                            // console.log(date.format('D'));
                        });

                        this.refreshEnabled()
                    });
            });
        /*Read Data*/
    }
    //store xml data into array variable
    parseXML(data, defaultThumb) {
        return new Promise(resolve => {
            var k: string | number,
                arr = [],
                parser = new xml2js.Parser(
                    {
                        trim: true,
                        explicitArray: true
                    });
            parser.parseString(data, function (err, result) {
                var obj = result.tv;

                const getThumbnail = function (icon: any): string {
                    var i = 0
                    // try {
                        if (icon) {
                            while (icon[i] && icon[i].$.src != '') {
                                if( !icon[i].$.src.includes('portrait') ) {
                                    return icon[i].$.src
                                }

                                // if (icon[i].$.width - icon[i].$.height > 0) {
                                //     return icon[i].$.src
                                // }
                            }
                            i++
                        }
                    // }
                    // catch (e) { }
                    return ''
                }



                for (k in result.tv.programme) {
                    var item = new Show();
                    var data = result.tv.programme[k];
                    if (data && data.title) {

                        item.title = data.title[0]._
                        item.description = data.desc ? data.desc[0]._ : ''
                        item.genre = data.category ? data.category[0]._ : ''
                        item.ratingAge = data.rating ? data.rating[0].value[0] : ''

                        var startStr = data.$.start
                        var endStr = data.$.stop

                        var startMoment = moment(startStr, 'YYYYMMDDHHmmss ZZ')
                        var endMoment = moment(endStr, 'YYYYMMDDHHmmss ZZ')

                        item.start = Timestamp.fromDate(startMoment.toDate())
                        item.end = Timestamp.fromDate(endMoment.toDate())
                        item.thumbnail = ''
                        // item.thumbnail = getThumbnail(data.icon)
                        var done = false
                        if (data.icon) {

                            data.icon.forEach(iconObj => {
                                if (!done) {
                                    if (parseInt(iconObj.$.width) - parseInt(iconObj.$.height) > 0 ) {
                                        done = true
                                        item.thumbnail = iconObj.$.src
                                    }
                                }
                            })
                        }
                        else {
                            console.log('no image')
                        }

                        if (item.thumbnail == '') {
                            item.thumbnail = defaultThumb

                        }
                        if (arr.length == 327) {
                            console.log('debug');
                        }
                        if (item.title.indexOf("To Be Announced") != -1) {
                            console.log('empty')
                            item.disabled = true;
                        }
                        if (item.description && item.description.includes('Program information is not yet available')) {
                            console.log('empty 2')
                        }

                        console.log(item.title, arr.length)

                        if (endMoment.diff(moment()) > 0) {
                            item.init()

                            arr.push(item)
                        }

                    }
                    else {
                        console.error('parsing data error: ' + k)
                        console.error(result.tv.programme[k])
                    }
                }
                console.log(arr[327])

                resolve(arr);
            });
        });
    }

    

    // selects a day to display
    selectDay(day: string): void {
        this.dayIDSelected = day

        let index = this.daysList.findIndex((item) => item.id == this.dayIDSelected)
        if (index == -1) {
            console.error('day not found')
        }
        this.daySelected = this.daysList[index]
        this.daySelected.list = this.daySelected.list.sort((a, b) => a.start.seconds - b.start.seconds)
    }

    getDayIDSelected(): string {
        return this.dayIDSelected
    }

    getDaySelected(): Day {
        return this.daySelected;
    }

    getAllTitles(title: string) {
        let retVal = [];

        this.daysList.forEach((day) => {

            day.list.forEach(element => {
                console.log(element.title + ' / ' + element.series)
                if (element.title == title || element.series == title) {
                    // console.log(element);
                    retVal.push(element);
                }
            });
        })

        return retVal;
    }

    getAllTitlesFromList(title: string, list: Day[]) {
        let retVal = [];

        this.daysList.forEach((day) => {

            day.list.forEach(element => {
                if (element.title == title || element.series == title) {
                    console.log(element);
                    retVal.push(element);
                }
            });
        })

        return retVal;
    }
}
